
import RegisterBox from '@/components/Entrance/Register/RegisterBox.vue';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Register',
  components: {
    RegisterBox,
  },
  setup() {},
});
